/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { settings } from "@/libraries/storage";
import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({
    name: 'CoreStore',
    namespaced: true,
})
export default class CoreStore extends VuexModule {
    appOnline: boolean = navigator.onLine
    hasNotificationCapability = false
    hasNotificationEnabled: boolean = settings.has('cloud', 'fcm', 'token')
    hasShareCapability: boolean = (navigator.share !== undefined)
    installation: any | false = false
    serviceWorkerRegistration: ServiceWorkerRegistration | false = false
    swUpdateCheck = false
    swUpdateDownloading = false

    @Mutation
    setAppOnline(status: boolean): void {
        this.appOnline = status
    }

    @Mutation
    setHasNotificationCapability(status: boolean): void {
        this.hasNotificationCapability = status
    }

    @Mutation
    setHasNotificationEnabled(status: boolean): void {
        this.hasNotificationEnabled = status
    }

    @Mutation
    setInstallation(installation: any | false): void {
        this.installation = installation
    }

    @Mutation
    setServiceWorkerRegistration(serviceWorkerRegistration: ServiceWorkerRegistration | false): void {
        this.serviceWorkerRegistration = serviceWorkerRegistration
    }

    @Mutation
    setSwUpdateCheck(status: boolean): void {
        this.swUpdateCheck = status
    }

    @Mutation
    setSwUpdateDownloading(status: boolean): void {
        this.swUpdateDownloading = status
    }
}
